// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-reset-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: radial-gradient(120% 140% at 15% 10%, #132b4d 0%, #0a1628 62%);
  padding: 20px;
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.reset-card {
  background: #fbf9f4;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  animation: slideUp 0.4s ease-out;
  border: 1px solid rgba(198, 161, 91, 0.25);
}

.reset-card.error-card {
  text-align: center;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.reset-card h2 {
  font-family: 'Fraunces', Georgia, serif;
  color: #0a1628;
  margin-bottom: 30px;
  text-align: center;
  font-size: 26px;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #48546b;
  font-weight: 600;
  font-size: 13px;
}

.form-group input {
  width: 100%;
  padding: 12px;
  border: 1.5px solid #e3ddcd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
  background: #ffffff;
  color: #0a1628;
}

.form-group input:focus {
  outline: none;
  border-color: #c6a15b;
  box-shadow: 0 0 0 3px rgba(198, 161, 91, 0.16);
}

.form-group input:disabled {
  background-color: #f1ede2;
  cursor: not-allowed;
}

.btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: #0a1628;
  color: #e3c98a;
}

.btn-primary:hover:not(:disabled) {
  background-color: #132b4d;
  box-shadow: 0 4px 15px rgba(10, 22, 40, 0.4);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-message {
  background-color: #e3efe9;
  color: #245349;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #2f6f5e;
  display: flex;
  align-items: center;
  gap: 8px;
}

.success-message span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-message {
  background-color: #fbeae5;
  color: #8a3322;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #b3432b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.error-message span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.password-requirements {
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e3ddcd;
}

.password-requirements p {
  color: #48546b;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 600;
}

.password-requirements ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.password-requirements li {
  color: #8792a6;
  font-size: 13px;
  padding: 5px 0;
  padding-left: 20px;
  position: relative;
}

.password-requirements li:before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #2f6f5e;
  font-weight: bold;
}

/* Responsive design */
@media (max-width: 480px) {
  .reset-card {
    padding: 30px 20px;
  }

  .reset-card h2 {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .form-group input {
    font-size: 16px;
    padding: 12px;
  }

  .btn {
    padding: 12px;
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PasswordReset.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,0EAA0E;EAC1E,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".password-reset-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: radial-gradient(120% 140% at 15% 10%, #132b4d 0%, #0a1628 62%);\n  padding: 20px;\n  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.reset-card {\n  background: #fbf9f4;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  animation: slideUp 0.4s ease-out;\n  border: 1px solid rgba(198, 161, 91, 0.25);\n}\n\n.reset-card.error-card {\n  text-align: center;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.reset-card h2 {\n  font-family: 'Fraunces', Georgia, serif;\n  color: #0a1628;\n  margin-bottom: 30px;\n  text-align: center;\n  font-size: 26px;\n  font-weight: 600;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #48546b;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px;\n  border: 1.5px solid #e3ddcd;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n  background: #ffffff;\n  color: #0a1628;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #c6a15b;\n  box-shadow: 0 0 0 3px rgba(198, 161, 91, 0.16);\n}\n\n.form-group input:disabled {\n  background-color: #f1ede2;\n  cursor: not-allowed;\n}\n\n.btn {\n  width: 100%;\n  padding: 12px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-primary {\n  background: #0a1628;\n  color: #e3c98a;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #132b4d;\n  box-shadow: 0 4px 15px rgba(10, 22, 40, 0.4);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.success-message {\n  background-color: #e3efe9;\n  color: #245349;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border-left: 4px solid #2f6f5e;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.success-message span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error-message {\n  background-color: #fbeae5;\n  color: #8a3322;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  border-left: 4px solid #b3432b;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.error-message span {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.password-requirements {\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 1px solid #e3ddcd;\n}\n\n.password-requirements p {\n  color: #48546b;\n  font-size: 14px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.password-requirements ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.password-requirements li {\n  color: #8792a6;\n  font-size: 13px;\n  padding: 5px 0;\n  padding-left: 20px;\n  position: relative;\n}\n\n.password-requirements li:before {\n  content: '✓';\n  position: absolute;\n  left: 0;\n  color: #2f6f5e;\n  font-weight: bold;\n}\n\n/* Responsive design */\n@media (max-width: 480px) {\n  .reset-card {\n    padding: 30px 20px;\n  }\n\n  .reset-card h2 {\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n\n  .form-group input {\n    font-size: 16px;\n    padding: 12px;\n  }\n\n  .btn {\n    padding: 12px;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
